<template>
    <div>
        <div v-if="msgType == 'text'" ref="msgDiv" class="msgP"></div>
        <p v-if="msgType == 'link'" class="msgP"><a style="color:#1890ff;text-decoration: underline;" :href="content" target="_blank">{{content}}</a></p>
        <el-image v-if="msgType == 'image'" style="width: 100px; height: 100px" :src="baseImgURL + content"
                                :preview-src-list="(baseImgURL + content).split('{yuneasy}')" fit="contain"></el-image>
        <audio v-if="msgType == 'voice'" :src="baseImgURL + content" controls style="height: 30px;"> </audio>
        <video v-if="msgType == 'video'" width="200" height="115" controls :src="baseImgURL + content"/>
    </div>
</template>
<script>
export default {
    name: "Msg",
    data(){
        return {
            emojiList: require('@/assets/emotion.json'),
          }
    },
    model: {
        prop: 'content',
    },
    props: {
      msgType: String,
      content: String
    },
    mounted(){
        if(this.msgType == "text"){
          let msgContent = this.content;
            if(msgContent.indexOf('/:') > -1){
                for(let i = 0; i < this.emojiList.length; i++){
                    for(let n = 0; n < this.emojiList[i].length; n++){
                        let newChar = this.htmlToString(this.emojiList[i][n].chars);
                        msgContent = msgContent.replace(new RegExp(RegExp.escape(newChar),'g'),"<img src='"+ this.emojiList[i][n].emoji+"'/>");
                    }
                }
            }
            this.$refs.msgDiv.innerHTML = msgContent;
        }
        RegExp.escape= function(s) {
          return s.replace(/[-\/:\\^$*+?.()|[\]{}><@&]/g, '\\$&');
        };
    },
    methods:{
      htmlToString:function (sHtml) {
        return sHtml.replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
      },
    },
}
</script>
<style scoped lang="less">
.msgP{
    word-wrap: break-word;
	word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/Msg.vue